<template>
  <article class="content appBox" id="content">
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta || !$route.meta.keepAlive"></router-view>
    <commen-foot id="foot"></commen-foot>
    <ICP></ICP>
  </article>
</template>
<script>
import commenFoot from "@/components/Foot";
import ICP from "@/components/ICP";
export default {
  components: {
    commenFoot,ICP
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.appBox {
  position: absolute;
  min-width: 1200px;
  max-width: 1920px;
  width: 100%;
  height: 100%;
  font-family: Noto Sans S Chinese;
  margin: 0 auto;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  padding-top: 64px;
}
.content {
  position: relative;
  min-height: calc(100% - 355px); //减头355px(高度+底部)
  background-color: #f8f6f7;
}

@media screen and (max-width: 767px) {
  .content {
    margin-top: 120px;
  }
}
</style>

